import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { App } from "./app";
import { installMarketingAnalytics } from "./marketing-analytics";
import {
  isMarketingPath,
  MarketingNotFoundPage,
  MarketingPage,
} from "./marketing";
import "./styles.css";

const assetRefreshKey = "buying-lane:last-asset-refresh";
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  const currentTime = Date.now();
  const lastRefresh = Number(window.sessionStorage.getItem(assetRefreshKey) ?? 0);
  if (!Number.isFinite(lastRefresh) || currentTime - lastRefresh > 60_000) {
    window.sessionStorage.setItem(assetRefreshKey, String(currentTime));
    window.location.reload();
  }
});

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root");

const marketingRoute = root.dataset.marketingRoute;
const application =
  marketingRoute && isMarketingPath(marketingRoute) ? (
    <MarketingPage pathname={marketingRoute} />
  ) : root.dataset.marketingNotFound === "true" ? (
    <MarketingNotFoundPage />
  ) : (
    <App />
  );

if (marketingRoute) {
  hydrateRoot(root, <StrictMode>{application}</StrictMode>);
} else {
  createRoot(root).render(<StrictMode>{application}</StrictMode>);
}

installMarketingAnalytics();
